import React from "react";
import Field from "containers/Field/Field";

//import PropTypes from 'prop-types';

export function LayoutSettings(props) {
    const {} = props;
    return (
        <div className={"rows gap-md"}>
            <Field
                id={"partial"}
                label={"Częściowa treść (np popup)"}
                fieldType={"checkbox"}
            />
        </div>
    );
}

LayoutSettings.propTypes = {};

LayoutSettings.defaultProps = {};

export default LayoutSettings;
